import React, { useEffect, useState } from 'react';
import './TimeUpdate.less';

const TimeUpdate = ({ onUpdate }) => {
  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountdown(prev => {
        if (prev === 1) {
          onUpdate();
          return 30;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [onUpdate]);

  return (
    <div className="time-update-indicator">
    　<span className="countdown"> 
        <span className="countdown-number">{countdown}</span>
        <span>秒</span>
    　</span>
      <span>後更新</span>
    </div>
  );
};

export default TimeUpdate;
